import http from '@/axios/http';

export const getHometown = (parameters) => {
  return http.post('/api/page-one', parameters);
};
